




import Vue from "vue";
import NotificationDataResult from "@/components/notification-data/notification-data-result.component.vue";
export default Vue.extend({
  components: {
    "notification-data-result": NotificationDataResult,
  },
});
